import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SeccionBannerEnvia } from 'src/app/models/administrador/seccion-banner-envia';

@Injectable({
    providedIn: 'root'
  })
export class BannerService {
  
    private baseBanner = '/banner';

    public grises: boolean = false;
  
    constructor(private http: HttpClient) { }
  
    saveSeccionBanner(seccionBannerEnvia: SeccionBannerEnvia, listaImg: File[]): Observable<any> {
        let headers = new Headers();
        let form = new FormData();
        for(let i =0; i < listaImg.length; i++){
          form.append("files", listaImg[i]);
        }
        form.append("orden", seccionBannerEnvia.orden);
        form.append("imgColorAncho", seccionBannerEnvia.imgColorAncho);
        form.append("imgColorAlto", seccionBannerEnvia.imgColorAlto);
        form.append("imgColorPeso", seccionBannerEnvia.imgColorPeso);
        form.append("imgBlancoYNegroAncho", seccionBannerEnvia.imgBlancoYNegroAncho);
        form.append("imgBlancoYNegroAlto", seccionBannerEnvia.imgBlancoYNegroAlto);
        form.append("imgBlancoYNegroPeso", seccionBannerEnvia.imgBlancoYNegroPeso);
        form.append("descripcionLector", seccionBannerEnvia.descripcionLector);
        form.append("descripcionTooltip", seccionBannerEnvia.descripcionTooltip);
        form.append("urlAsociada", seccionBannerEnvia.urlAsociada);
        form.append("targetBlank", seccionBannerEnvia.targetBlank);
        form.append("estado", seccionBannerEnvia.estado);
        headers.append("Content-Type", "multipart/form-data");
        return this.http.post(`${environment.backend.concat(this.baseBanner).concat('/crearSeccionBanner')}`, form, { responseType: 'text' });
        
    }

    getListaOrdenMasUno(): Observable<any> {
      return this.http.get(`${environment.backend.concat(this.baseBanner).concat('/obtenerListaOrdenMasUno')}`);
    }

    getListaOrden(): Observable<any> {
      return this.http.get(`${environment.backend.concat(this.baseBanner).concat('/obtenerListaOrden')}`);
    }

    getListAllSeccionBanner(): Observable<any> {
      return this.http.get(`${environment.backend.concat(this.baseBanner).concat('/obtenerListaSeccionBanner')}`);
    }

    getSeccionBanner(idSeccionBanner: number): Observable<any> {
      return this.http.get(`${environment.backend.concat(this.baseBanner).concat('/obtenerSeccionBanner')}/${idSeccionBanner}`);
    }

    actualizarSeccionBanner(seccionBannerEnvia: SeccionBannerEnvia, listaImg: File[]): Observable<any> {
      let headers = new Headers();
      let form = new FormData();

      console.log("imgBlancoYNegro");
      console.log(listaImg[1]);

      for(let i =0; i < listaImg.length; i++){
        form.append("files", listaImg[i]);
      }
      form.append("idSeccionBanner", seccionBannerEnvia.idSeccionBanner);
      form.append("orden", seccionBannerEnvia.orden);
      form.append("imgColorAncho", seccionBannerEnvia.imgColorAncho);
      form.append("imgColorAlto", seccionBannerEnvia.imgColorAlto);
      form.append("imgColorPeso", seccionBannerEnvia.imgColorPeso);
      form.append("imgBlancoYNegroAncho", seccionBannerEnvia.imgBlancoYNegroAncho);
      form.append("imgBlancoYNegroAlto", seccionBannerEnvia.imgBlancoYNegroAlto);
      form.append("imgBlancoYNegroPeso", seccionBannerEnvia.imgBlancoYNegroPeso);
      form.append("descripcionLector", seccionBannerEnvia.descripcionLector);
      form.append("descripcionTooltip", seccionBannerEnvia.descripcionTooltip);
      form.append("urlAsociada", seccionBannerEnvia.urlAsociada);
      form.append("targetBlank", seccionBannerEnvia.targetBlank);
      headers.append("Content-Type", "multipart/form-data");
      return this.http.post(`${environment.backend.concat(this.baseBanner).concat('/editarSeccionBanner')}`, form, { responseType: 'text' });
    }

    actualizarSeccionBannerSinImgColor(seccionBannerEnvia: SeccionBannerEnvia, imgBlancoYNegro: File): Observable<any> {
      let headers = new Headers();
      let form = new FormData();
      form.append("imgBlancoYNegro", imgBlancoYNegro);
      form.append("idSeccionBanner", seccionBannerEnvia.idSeccionBanner);
      form.append("orden", seccionBannerEnvia.orden);
      form.append("imgBlancoYNegroAncho", seccionBannerEnvia.imgBlancoYNegroAncho);
      form.append("imgBlancoYNegroAlto", seccionBannerEnvia.imgBlancoYNegroAlto);
      form.append("imgBlancoYNegroPeso", seccionBannerEnvia.imgBlancoYNegroPeso);
      form.append("descripcionLector", seccionBannerEnvia.descripcionLector);
      form.append("descripcionTooltip", seccionBannerEnvia.descripcionTooltip);
      form.append("urlAsociada", seccionBannerEnvia.urlAsociada);
      form.append("targetBlank", seccionBannerEnvia.targetBlank);
      headers.append("Content-Type", "multipart/form-data");
      return this.http.post(`${environment.backend.concat(this.baseBanner).concat('/editarSeccionBannerSinImgColor')}`, form, { responseType: 'text' });
    }

    actualizarSeccionBannerSinImgBlancoYNegro(seccionBannerEnvia: SeccionBannerEnvia, imgColor: File): Observable<any> {
      let headers = new Headers();
      let form = new FormData();
      form.append("imgColor", imgColor);
      form.append("idSeccionBanner", seccionBannerEnvia.idSeccionBanner);
      form.append("orden", seccionBannerEnvia.orden);
      form.append("imgColorAncho", seccionBannerEnvia.imgColorAncho);
      form.append("imgColorAlto", seccionBannerEnvia.imgColorAlto);
      form.append("imgColorPeso", seccionBannerEnvia.imgColorPeso);
      form.append("descripcionLector", seccionBannerEnvia.descripcionLector);
      form.append("descripcionTooltip", seccionBannerEnvia.descripcionTooltip);
      form.append("urlAsociada", seccionBannerEnvia.urlAsociada);
      form.append("targetBlank", seccionBannerEnvia.targetBlank);
      headers.append("Content-Type", "multipart/form-data");
      return this.http.post(`${environment.backend.concat(this.baseBanner).concat('/editarSeccionBannerSinImgBlancoYNegro')}`, form, { responseType: 'text' });
    }

    actualizarSeccionBannerSinImagenes(seccionBannerEnvia: SeccionBannerEnvia): Observable<any> {
      let headers = new Headers();
      let form = new FormData();
      form.append("idSeccionBanner", seccionBannerEnvia.idSeccionBanner);
      form.append("orden", seccionBannerEnvia.orden);
      form.append("descripcionLector", seccionBannerEnvia.descripcionLector);
      form.append("descripcionTooltip", seccionBannerEnvia.descripcionTooltip);
      form.append("urlAsociada", seccionBannerEnvia.urlAsociada);
      form.append("targetBlank", seccionBannerEnvia.targetBlank);
      headers.append("Content-Type", "multipart/form-data");
      return this.http.post(`${environment.backend.concat(this.baseBanner).concat('/editarSeccionBannerSinImagenes')}`, form, { responseType: 'text' });
    }

    actualizarEstadoSeccionBanner(idSeccionBanner: number, estado: number) {
      return this.http.put(`${environment.backend.concat(this.baseBanner).concat('/actualizarEstadoSeccionBanner')}/${idSeccionBanner}`, estado, { responseType: 'text' });
    }

    deleteSeccionBanner(idSeccionBanner: number): Observable<any> {
      return this.http.delete(`${environment.backend.concat(this.baseBanner).concat('/eliminarSeccionBanner')}/${idSeccionBanner}`);
    }
  
  }
